/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react'
import { jsx, Box, Text, Image } from 'theme-ui'
import styles from './styles'

const PrizesSection = ({ cmsContent, id }) => {
  const isFivePrizes = cmsContent?.items.length === 5
  const isSixPrizes = cmsContent?.items.length === 6

  return (
    <Box id={id} sx={styles.mainContainer}>
      <Text sx={styles.sectionTitle} as="h2">
        {cmsContent?.title}
      </Text>
      {cmsContent?.items.length &&
        cmsContent.items.map(
          (
            {
              text,
              image,
              description,
              positionText,
              singleFullWidthItem,
              singleFullWidthImageOnly,
              singleFullWidthSmallImageOnly,
            },
            index,
          ) => (
            <React.Fragment key={`item-${index}`}>
              {singleFullWidthImageOnly || singleFullWidthSmallImageOnly ? (
                <Image
                  sx={
                    singleFullWidthImageOnly
                      ? styles.singleImageCard
                      : styles.singleSmallImageCard
                  }
                  src={image}
                />
              ) : (
                <Box
                  sx={{
                    ...styles.itemsCard,
                    ...(isFivePrizes && { ...styles.isFivePrizes }),
                    ...(isSixPrizes && { ...styles.isSixPrizes }),
                    ...(singleFullWidthItem && { ...styles.singleItemCard }),
                  }}
                >
                  <Box sx={styles.badgeIcon(singleFullWidthItem)}>
                    <span>{positionText}</span>
                  </Box>
                  <Image src={image} />
                  <Text as="h3">{text}</Text>
                  <Text as="p">{description}</Text>
                </Box>
              )}
            </React.Fragment>
          ),
        )}
    </Box>
  )
}

export default PrizesSection
